module.exports = __webpack_public_path__ + "img/logo-conservatorio.0cd39513.png";